import { useLazyQuery } from '@apollo/client';
import { SearchInput, SearchOutboundInterfaceResult } from '@bechtel/ht-types';
import { useCallback } from 'react';
import { SEARCH_OUTBOUND_INTERFACE } from '~/gql';

export const useSearchOutboundInterface = () => {
  const [searchOutboundInterfaceQuery, { data, loading, error, fetchMore, refetch, networkStatus }] = useLazyQuery<
    { searchOutboundInterfaces: SearchOutboundInterfaceResult },
    { searchInput: SearchInput }
  >(SEARCH_OUTBOUND_INTERFACE);

  const searchOutboundInterfaces = useCallback(
    (searchInput: SearchInput, onComplete?: (data) => void) => {
      searchOutboundInterfaceQuery({
        variables: {
          searchInput: searchInput,
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-first',
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data.searchOutboundInterfaces);
          }
        },
      });
    },
    [searchOutboundInterfaceQuery]
  );

  return { searchOutboundInterfaces, data, loading, error, refetch, networkStatus, fetchMore };
};
